/**
 * Reads the build-time `REACT_APP_CLIENT` value, injected from the Bitbucket
 * pipeline variable `$CLIENT`. Use to gate per-client features (e.g. demo-only
 * UI affordances).
 */
export const getClient = (): string =>
  (process.env.REACT_APP_CLIENT ?? "").toLowerCase().trim();

export const isDemoClient = (): boolean => getClient() === "demo";
